import { contains, filter, last, length, map } from "@pdfking/rfunc"
import { All, Zip } from "@pdfking/tfunc"
import { defineComponent } from "vue"
import autocomplete from "../constants/autocomplete"

export default defineComponent({
  components: {},
  computed: {
    objects() {
      const response = (autocomplete as any)[this.autocomplete]
      return response ? response.objects : null
    },

    sizes() {
      if (this.objects) {
        const unit_filter = length(this.units)
          ? (formatted: string) =>
              contains(this.units, last(formatted.split(" ")))
          : (_formatted: string) => true

        const is_contained = (measures: number[]) =>
          All(
            Zip(this.min, measures, this.max),
            ([min, current, max]: [number, number, number]) =>
              current >= min && current <= max
          )

        return map(
          ([name, formatted, ..._sizes]: [string, string, ...number[]]) => [
            name,
            formatted,
          ],
          filter(
            ([_name, formatted, ...sizes]: [string, string, ...number[]]) =>
              unit_filter(formatted) && is_contained(sizes),
            this.objects
          )
        )
      }
      return null
    },
  },

  props: ["id", "autocomplete", "units", "min", "max", "target"] as const,
  render() {
    if (!this.objects) return null
    return (
      <datalist id={this.id}>
        {this.sizes.map(([name, size]: [string, string]) => (
          <option key={size} value={size} innerHTML={name} />
        ))}
      </datalist>
    )
  },
})
